/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Rank_Command_BodyInputs */



/**
* | output |
* | --- |
* | "A member's card, level and place, posted as a picture." |
*
* @param {Features_Rank_Command_BodyInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const features_rank_command_body = /** @type {((inputs?: Features_Rank_Command_BodyInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Rank_Command_BodyInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Карточка, уровень и место участника — картинкой в канале.")
	return /** @type {LocalizedString} */ ("A member's card, level and place, posted as a picture.")
});